module.exports = __webpack_public_path__ + "static/media/iso-bg.a54b64f1.png";